/**
 * Returns whether the given string is a valid ISO date string.
 *
 * Does not support timezone offsets.
 */
export const isValidDateISOString = (value: string): boolean => {
  const date = new Date(value);

  return !isNaN(date.getTime()) && date.toISOString() === value;
};
